<template>
    <div class="layout">
        <div class="layout__header">
            <div class="layout__title">
                <h3>Ecas</h3>
            </div>
        </div>
        <div class="row">
            <div v-show="lineas.length > 1" class="col-xs-12 col-md-4">
                <div class="form-field select2">
                    <div class="select2-field">
                        <v-select @input="inputLinea" :options="lineas" label="name" id="linea" placeholder="Seleccione..." v-model="selectedLinea"></v-select>
                        <label for="linea">Línea</label>
                        <span v-if="errores.linea_id" class="helper-text text-danger" slot="helper">
                            <strong>{{ errores.linea_id[0] }}</strong>
                        </span>
                    </div>
                </div>
            </div>
            <div class="col-xs-12 col-md-4">
                <div class="form-field select2">
                    <div class="select2-field">
                        <v-select label="address" @input="inputYard" :options="yards" id="yard_code" placeholder="Seleccione..." v-model="selectedYard"></v-select>
                        <label for="yard_code">Patio</label>
                        <span v-if="errores.yard_code" class="helper-text text-danger" slot="helper">
                            <strong>{{ errores.yard_code[0] }}</strong>
                        </span>
                    </div>
                </div>
            </div>
            <div class="col-xs-12 col-md-4">
                <div class="form-field">
                    <input-field :readonly="tipoFormulario !== 'N'" id="numero_oficio" v-model="form.numero_oficio" placeholder="# Oficio">
                        <span>Número de oficio</span>
                        <span v-if="errores.numero_oficio" class="helper-text text-danger" slot="helper">
                            <strong>{{ errores.numero_oficio[0] }}</strong>
                        </span>
                    </input-field>
                </div>
            </div>
            <div class="col-xs-12 col-md-4">
                <div class="form-field">
                    <input-field :readonly="tipoFormulario !== 'N'" id="contenedor" v-model="form.contenedor" placeholder="#######">
                        <span>Contenedor</span>
                        <span v-if="errores.contenedor" class="helper-text text-danger" slot="helper">
                            <strong>{{ errores.contenedor[0] }}</strong>
                        </span>
                    </input-field>
                </div>
            </div>
            <div class="col-xs-12 col-md-4">
                <div class="form-field select2">
                    <div class="select2-field">
                        <v-select taggable :options="naves" label="nave" id="nave" placeholder="Seleccione..." v-model="form.nave"></v-select>
                        <label for="nave">Nave</label>
                        <span v-if="errores.nave" class="helper-text text-danger" slot="helper">
                            <strong>{{ errores.nave[0] }}</strong>
                        </span>
                    </div>
                </div>
            </div>
            <div class="col-xs-12 col-md-4">
                <div class="form-field">
                    <input-field id="viaje" v-model="form.viaje" placeholder="Viaje">
                        <span>Viaje</span>
                        <span v-if="errores.viaje" class="helper-text text-danger" slot="helper">
                            <strong>{{ errores.viaje[0] }}</strong>
                        </span>
                    </input-field>
                    </div>
            </div>
            <div class="col-xs-12 col-md-4">
                <div class="form-field">
                    <input-field id="embarque" v-model="form.embarque" placeholder="Embarque">
                        <span>Embarque</span>
                        <span v-if="errores.embarque" class="helper-text text-danger" slot="helper">
                            <strong>{{ errores.embarque[0] }}</strong>
                        </span>
                    </input-field>
                </div>
            </div>
            <div class="col-xs-12 col-md-4">
                <div class="form-field">
                    <div class="datepicker-field">
                        <date-picker type="date" id="arriva_nave" v-model="form.arriva_nave"></date-picker>
                        <label>Fecha de Nave</label>
                        <span v-if="errores.arriva_nave" class="helper-text text-danger" slot="helper">
                            <strong>{{ errores.arriva_nave[0] }}</strong>
                        </span>
                    </div>
                </div>
            </div>
            <div class="col-xs-12 col-md-4">
                <div class="form-field">
                    <input-field v-model="form.importador" placeholder="Imp" id="importador">
                        Importador
                        <span v-if="errores.importador" class="helper-text text-danger" slot="helper">
                            <strong>{{ errores.importador[0] }}</strong>
                        </span>
                    </input-field>
                </div>
            </div>
            <div class="col-xs-12 col-md-4">
                <div class="form-field">
                    <div class="form-field">
                        <input-field v-model="form.ruc_importador" placeholder="RUC" id="importador">
                            RUC Importador
                            <span v-if="errores.ruc_importador" class="helper-text text-danger" slot="helper">
                                <strong>{{ errores.ruc_importador[0] }}</strong>
                            </span>
                        </input-field>
                    </div>
                </div>
            </div>
            <div class="col-xs-12 col-md-4">
                <div class="form-field select2">
                    <div class="select2-field">
                        <v-select taggable :options="telefonos" id="tel_importador" placeholder="Seleccione..." v-model="form.tel_importador"></v-select>
                        <label for="tel_importador">Tel. Importador</label>
                        <span v-if="errores.tel_importador" class="helper-text text-danger" slot="helper">
                            <strong>{{ errores.tel_importador[0] }}</strong>
                        </span>
                    </div>
                </div>
            </div>
            <div class="col-xs-12 col-md-4">
                <div class="form-field select2">
                    <div class="form-group">
                        <div class="select-field">
                            <select v-model="form.size" name="size" id="size">
                                <option value="4">4</option>
                                <option value="2">2</option>
                            </select>
                            <label for="tipo_contenedor">Tipo de contenedor</label>
                        </div>
                        <div class="select2-field">
                            <v-select @input="inputTipoContenedor" :options="tiposContenedor" label="descripcion" id="tipo_contenedor" placeholder="Seleccione..." v-model="selectedTipoContenedor"></v-select>                      
                            <span v-if="errores.tipo_contenedor" class="helper-text text-danger" slot="helper">
                                <strong>{{ errores.tipo_contenedor[0] }}</strong>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xs-12 col-md-4">
                <div class="form-field">
                    <div class="datepicker-field">
                        <date-picker type="date" id="fecha_inicio" v-model="form.fecha_inicio"></date-picker>
                        <label>Fecha de inicio</label>
                        <span v-if="errores.fecha_inicio" class="helper-text text-danger" slot="helper">
                            <strong>{{ errores.fecha_inicio[0] }}</strong>
                        </span>
                    </div>
                </div>
            </div>
            <div class="col-xs-12 col-md-4">
                <div class="form-field">
                    <div class="datepicker-field">
                        <date-picker type="date" id="fecha_caducidad" v-model="form.fecha_caducidad"></date-picker>
                        <label>Fecha de caducidad</label>
                        <span v-if="errores.fecha_caducidad" class="helper-text text-danger" slot="helper">
                            <strong>{{ errores.fecha_caducidad[0] }}</strong>
                        </span>
                    </div>
                </div>
            </div>
            <div class="col-xs-12 col-md-4">
                <div class="form-field">
                    <input-field id="sello" v-model="form.sello" placeholder="#######">
                        <span>Sello</span>
                        <span v-if="errores.sello" class="helper-text text-danger" slot="helper">
                            <strong>{{ errores.sello[0] }}</strong>
                        </span>
                    </input-field>
                </div>
            </div>
            <div class="col-xs-12 col-md-4">
                <div class="form-field">
                    <input-field id="bl" v-model="form.bl" placeholder="#######">
                        <span>BL</span>
                        <span v-if="errores.bl" class="helper-text text-danger" slot="helper">
                            <strong>{{ errores.bl[0] }}</strong>
                        </span>
                    </input-field>
                </div>
            </div>
            <div class="col-xs-12 col-md-4">
                <div class="form-field">
                    <input-field id="mrn" v-model="form.mrn" placeholder="#######">
                        <span>MRN</span>
                        <span v-if="errores.mrn" class="helper-text text-danger" slot="helper">
                            <strong>{{ errores.mrn[0] }}</strong>
                        </span>
                    </input-field>
                </div>
            </div>
            <div class="col-xs-12 col-md-4">
                <div class="form-field">
                    <input-field id="marca" v-model="form.marca" placeholder="#######">
                        <span>Marca</span>
                        <span v-if="errores.marca" class="helper-text text-danger" slot="helper">
                            <strong>{{ errores.marca[0] }}</strong>
                        </span>
                    </input-field>
                </div>
            </div>
        </div>
        <div class="modal-buttons">
            <button @click="guardar" class="btn-success" type="button">
                <i class="fa fa-save"></i> <span>Guardar</span>
            </button>
            <button type="button" @click="$emit('cancelar')" class="btn-danger btn--text"><i class="fa fa-ban"></i><span>Cancelar</span></button>
        </div>
    </div>
</template>

<script>
export default {
    props : {
        yards : {
            type : Array,
            required : false,
            default : function () {
                return [];
            }
        },
        tipoFormulario : {
            type : String,
            required : false,
            default : 'N'
        },
        value : {
            type : Object,
            required : false,
            default : function () {
                return {
                    numero_oficio : '',
                    fecha_emision : moment(new Date()).format('YYYY-MM-DD'),
                    nave : '',
                    viaje : '',
                    embarque : '', 
                    linea : '',
                    arriva_nave : moment(new Date()).format('YYYY-MM-DD'),
                    mrn : '', 
                    bl : '', 
                    importador : '', 
                    ruc_importador : '', 
                    tel_importador : '', 
                    contenedor : '',
                    tipo_contenedor : '', 
                    fecha_inicio : moment(new Date()).format('YYYY-MM-DD'),
                    fecha_caducidad : moment(new Date()).format('YYYY-MM-DD'),
                    sello : '',
                    linea_id : '',
                    size : '4',
                    _method : undefined,
                    yard_code : '',
                    marca : ''
                };
            }
        },
        tiposContenedor : {
            type : Array,
            required : false,
            default : function () {
                return [];
            }
        },
        naves : {
            type : Array,
            required : false,
            default : function () {
                return [];
            }
        },
        telefonos : {
            type : Array,
            required : false,
            default : function () {
                return [];
            }
        },
        lineas : {
            type : Array,
            required : false,
            default : function () {
                return [];
            }
        }
    },
    data : function () {
        return {
            form : this.value,
            errores : {},
            selectedLinea : null,
            selectedTipoContenedor : null,
            selectedYard : null
        };
    },
    methods : {
        inputYard : function () {
            if (this.selectedYard !== null)
                this.form.yard_code = this.selectedYard.code;
            else 
                this.form.yard_code = '';
        },
        inputTipoContenedor : function () {
            if (this.selectedTipoContenedor !== null)
                this.form.tipo_contenedor = this.selectedTipoContenedor.id;
            else 
                this.form.tipo_contenedor = '';
        },
        guardar : function () {
            let that = this;
            swal({
                    title: '¿Desea almacenar los datos ingresados?',
                    type: 'question',
                    showCancelButton: true,
                    confirmButtonText: 'Aceptar',
                    cancelButtonText : 'Cancelar'
                    }).then((result) => {
                        if (result.value) {
                            if (that.tipoFormulario === 'E')
                                that.form._method = 'PUT';
                            else 
                                that.form._method = undefined;
                            axios.post(url + '/ecas' + (that.tipoFormulario === 'N'?'':'/' + that.form.contenedor), that.form).then(function (response) {
                                swal('Los datos fueron almacenados.', 'Realizado', 'success');
                                that.$emit('saved');
                            }).catch(function (error) {
                                if (error !== null && error !== undefined) {
                                    let response = error.response;
                                    if (response !== undefined && response !== null) {
                                        let status = response.status;
                                        if (status === 422) 
                                        {
                                            that.errores = response.data.errors;
                                            swal('Hay errores en el formulario.', 'Aviso', 'warning');
                                            return;
                                        }
                                    }
                                }
                                swal('Hubo un error, intente nuevamente.', 'Error', 'error');
                            });
                        }
                    });
        },
        inputLinea : function () {
            this.form.linea_id = this.selectedLinea.code;
        }
    },
    mounted : function () {
        if (this.lineas.length === 1) {
            this.selectedLinea = this.lineas[0];
            this.inputLinea();
        }
        else {
            let that = this;
            for (let i = 0; i < this.lineas.length; i++)
                if (this.lineas[i].code == this.form.linea_id) {
                    this.selectedLinea = this.lineas[i];
                    break;
                }
        } 
        for (let i = 0; i < this.tiposContenedor.length; i++) {
            if (this.tiposContenedor[i].id == this.form.tipo_contenedor) {
                this.selectedTipoContenedor = this.tiposContenedor[i];
                break;
            }
        }
        if (this.form.yard_code != null && this.form.yard_code !== '') 
            for (let i = 0; i < this.yards.length; i++) {
                if (this.yards[i].code == this.form.yard_code) {
                    this.selectedYard = this.yards[i];
                    break;
                }
            }
            
    }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/ecas-coparn/Ecas.vue